import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../common/services/common.service';
import { GlobalConstants } from '../../../common/constants/global.constant';
import * as formFactorsConfigData from './../../../../assets/config/form-factors.json';
import { FormFactorsConfig, FormFactor } from './interfaces/form-factors.i';
import { AppGlobal } from '../../../core/state/app-global';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { User } from '../../account/login/_models/user.model';

@Component({
  selector: 'iposcen-form-factors',
  templateUrl: './form-factors.component.html',
  styleUrls: ['./form-factors.component.scss']
})
export class FormFactorsComponent implements OnInit {
  @ViewChild('formFactorsModal') private modalContent: TemplateRef<FormFactorsComponent>;
  @Input() contentName: FormFactor;
  @Input() isAllEnabled = false;
  @Output() readonly applyFormFactor = new EventEmitter();
  manufacturersForm: FormGroup;
  deviceTypesForm: FormGroup;
  processorsForm: FormGroup;
  generationsForm: FormGroup;
  selectedFormFactors: FormFactor;
  selectAllManufacChecked: boolean;
  selectAllDeviceChecked: boolean;
  selectAllProcChecked: boolean;
  selectAllProcDisabled: boolean = false;
  selectAllGenChecked: boolean;
  isNoneSelected = [false, false, false, false];
  noOneSelected = false;
  errorMessage = '';
  errorColumns: string[] = [];
  direction: string;
  deviceTypes = GlobalConstants.DEVICE_TYPES;
  manufacturers = GlobalConstants.MANUFACTURERS;
  processors = GlobalConstants.PROCESSORS;
  generations = GlobalConstants.GENERATIONS;
  userRole: string;
  retailerConfig: any;
  selectAll = GlobalConstants.SELECT_ALL_TEXT;
  deselectAll = GlobalConstants.DESELECT_ALL_TEXT;
  retailerId;
  userId
  formFactorsConfigData: FormFactorsConfig = (formFactorsConfigData as any)
    .default;
  private modalRef: NgbModalRef;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private cmnService: CommonService,
    private appGlobal: AppGlobal
  ) { }
  initializeFormArray() {
    this.manufacturersForm = this.formBuilder.group({
      manufacturers: new FormArray([])
    });
    this.deviceTypesForm = this.formBuilder.group({
      deviceTypes: new FormArray([])
    });
    this.processorsForm = this.formBuilder.group({
      processors: new FormArray([])
    });
    this.generationsForm = this.formBuilder.group({
      generations: new FormArray([])
    });
  }
  ngOnInit(): void {
    this.direction = this.cmnService.direction;
    this.selectedFormFactors = JSON.parse(JSON.stringify(this.contentName));
    this.retailerId = sessionStorage.getItem('retailerId');
    this.userId = sessionStorage.getItem(GlobalConstants.USER_ID);
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (userAccount: User) => {
        this.userRole = userAccount.role;
        if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.REGIONALHQ) {
          this.retailerConfig = (userAccount.configurations !== undefined) ? JSON.parse(userAccount.configurations) : await this.cmnService.getRetailerConfig(this.userId,this.retailerId);
        }
      });
    this.addCheckboxes();
    this.initalizeFFOnChange();
  }

  initalizeFFOnChange() {
    this.deviceTypesForm.get('deviceTypes')
      .valueChanges
      .subscribe(value => {
        this.selectAllDeviceChecked = value.every(val => val);
        this.isNoneSelected[0] = value.every(val => !val) ? true : false;
        this.noOneSelected = false;
      });
    this.manufacturersForm.get('manufacturers').valueChanges
      .subscribe(value => {
        this.selectAllManufacChecked = value.every(val => val);
        this.isNoneSelected[1] = value.every(val => !val) ? true : false;
        this.noOneSelected = false;
      });
    this.processorsForm.get('processors').valueChanges
      .subscribe(value => {
        this.selectAllProcChecked = value.every(val => val);
        this.isNoneSelected[2] = value.every(val => !val) ? true : false;
        this.noOneSelected = false;
      });
    this.generationsForm.get('generations').valueChanges
      .subscribe(value => {
        this.selectAllGenChecked = value.every(val => val);
        this.isNoneSelected[3] = value.every(val => !val) ? true : false;
        this.noOneSelected = false;
      });
  }

  setAllValuesTrue(formArray: FormArray) {
    for (let control of formArray.controls) {
      if (control instanceof FormControl) {
        control.patchValue(true, { emitEvent: false });
      }
    }
  }

  setAllValuesFalse(formArray: FormArray) {
    for (let control of formArray.controls) {
      if (control instanceof FormControl) {
        control.patchValue(false, { emitEvent: false });
      }
    }
  }

  get manufacturersFormArray() {
    return this.manufacturersForm.controls.manufacturers as FormArray;
  }

  get deviceTypesFormArray() {
    return this.deviceTypesForm.controls.deviceTypes as FormArray;
  }

  get processorsFormArray() {
    return this.processorsForm.controls.processors as FormArray;
  }

  get generationsFormArray() {
    return this.generationsForm.controls.generations as FormArray;
  }
  addCheckboxes() {
    this.initializeFormArray();
    if (this.selectedFormFactors) {
      if (this.selectedFormFactors.devices === GlobalConstants.ALL) {
        this.selectAllDeviceChecked = true;
        this.formFactorsConfigData.deviceTypes.forEach(deviceType => {
          if (deviceType) {
            this.deviceTypesFormArray.push(new FormControl(true));
          }
        });
      } else {
        this.selectAllDeviceChecked = false;
        this.formFactorsConfigData.deviceTypes.forEach(deviceType => {
          if (this.selectedFormFactors.devices.indexOf(deviceType.name) >= 0) {
            this.deviceTypesFormArray.push(new FormControl(true));
          } else {
            this.deviceTypesFormArray.push(new FormControl(false));
          }
        });
      }
      if (this.selectedFormFactors.manufacturer === GlobalConstants.ALL) {
        this.selectAllManufacChecked = true;
        this.formFactorsConfigData.manufacturers.forEach(manufacturer => {
          if (manufacturer) {
            this.manufacturersFormArray.push(new FormControl(true));
          }
        });
      } else {
        this.selectAllManufacChecked = false;
        this.formFactorsConfigData.manufacturers.forEach(manufacturer => {
          if (this.selectedFormFactors.manufacturer.indexOf(manufacturer.name) >= 0) {
            this.manufacturersFormArray.push(new FormControl(true));
          } else {
            this.manufacturersFormArray.push(new FormControl(false));
          }
        });
      }
      if (this.selectedFormFactors.processors === GlobalConstants.ALL) {
        this.selectAllProcChecked = true;
        this.formFactorsConfigData.processors.forEach(processor => {
          if (this.cmnService.isFromAttractLoop && processor.name !== GlobalConstants.NON_INTEL) {
            this.processorsFormArray.push(new FormControl(true));
          } else if (!this.cmnService.isFromAttractLoop) {
            this.processorsFormArray.push(new FormControl(true));
          }
        });
      } else {
        this.selectAllProcChecked = false;
        this.formFactorsConfigData.processors.forEach(processor => {
          if (this.cmnService.isFromAttractLoop && processor.name !== GlobalConstants.NON_INTEL) {
            if (this.selectedFormFactors.processors.indexOf(processor.name) >= 0) {
              this.processorsFormArray.push(new FormControl(true));
            } else {
              this.processorsFormArray.push(new FormControl(false));
            }
          } else if (!this.cmnService.isFromAttractLoop){
            if ((processor.name === GlobalConstants.NON_INTEL && (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.REGIONALHQ) && !this.retailerConfig?.bcNonIntelDeviceEnabled) && !this.isAllEnabled && 
                this.cmnService.isBannerCarousel) {
              this.selectAllProcDisabled = true;
              this.processorsFormArray.push(new FormControl({ value: false, disabled: true }));
            } else {
              if (this.selectedFormFactors.processors.indexOf(processor.name) >= 0) {
                this.processorsFormArray.push(new FormControl(true));
              } else {
                this.processorsFormArray.push(new FormControl(false));
              }
            }
          }
        });
      }
      if (this.selectedFormFactors.generations === GlobalConstants.ALL) {
        this.selectAllGenChecked = true;
        this.formFactorsConfigData.generation.forEach(generation => {
          if (generation) {
            this.generationsFormArray.push(new FormControl(true));
          }
        });
      } else {
        this.selectAllGenChecked = false;
        this.formFactorsConfigData.generation.forEach(generation => {
          if (this.selectedFormFactors.generations.indexOf(generation.name) >= 0) {
            this.generationsFormArray.push(new FormControl(true));
          } else {
            this.generationsFormArray.push(new FormControl(false));
          }
        });
      }
    }
    /*
     this.isAnyOneOptionSelected(); */
  }

  isAnyOneOptionSelected() {
    this.isNoneSelected[1] =
      this.manufacturersForm.value.manufacturers.every(val => !val) ? true : false;
    this.isNoneSelected[0] =
      this.deviceTypesForm.value.deviceTypes.every(val => !val) ? true : false;
    this.isNoneSelected[2] =
      this.processorsForm.value.processors.every(val => !val) ? true : false;
    this.isNoneSelected[3] =
      this.generationsForm.value.generations.every(val => !val) ? true : false;
  }

  onSelectAllProcCheckboxChange(event) {
    this.noOneSelected = false;
    if (event.target.checked) {
      this.selectAllProcChecked = true;
      this.setAllValuesTrue(this.processorsFormArray);
    } else {
      this.selectAllProcChecked = false;
      this.setAllValuesFalse(this.processorsFormArray);
      this.isAnyOneOptionSelected();
    }
  }

  onSelectAllGenCheckboxChange(event) {
    this.noOneSelected = false;
    if (event.target.checked) {
      this.selectAllGenChecked = true;
      this.setAllValuesTrue(this.generationsFormArray);
    } else {
      this.selectAllGenChecked = false;
      this.setAllValuesFalse(this.generationsFormArray);
      this.isAnyOneOptionSelected();
    }
  }

  onSelectAllManufacCheckboxChange(event) {
    this.noOneSelected = false;
    if (event.target.checked) {
      this.selectAllManufacChecked = true;
      this.setAllValuesTrue(this.manufacturersFormArray);
    } else {
      this.selectAllManufacChecked = false;
      this.setAllValuesFalse(this.manufacturersFormArray);
      this.isAnyOneOptionSelected();
    }
  }

  onSelectAllDeviceCheckboxChange(event) {
    this.noOneSelected = false;
    if (event.target.checked) {
      this.selectAllDeviceChecked = true;
      this.setAllValuesTrue(this.deviceTypesFormArray);
    } else {
      this.selectAllDeviceChecked = false;
      this.setAllValuesFalse(this.deviceTypesFormArray);
      this.isAnyOneOptionSelected();
    }
  }

  open() {
    this.modalRef = this.modalService.open(this.modalContent, { centered: true, windowClass: 'form_factor_popup' });
    this.modalRef.result.then(
      result => {
      },
      reason => {
        this.selectedFormFactors = JSON.parse(JSON.stringify(this.contentName));
        this.addCheckboxes();
        this.initalizeFFOnChange();
        this.noOneSelected = false;
      }
    );
  }

  close(isClose?: boolean) {
    if (isClose) {
      this.selectedFormFactors = JSON.parse(JSON.stringify(this.contentName));
      this.addCheckboxes();
      this.initalizeFFOnChange();
      this.noOneSelected = false;
    }
    this.modalRef.close();
  }

  dismiss() {
    this.modalRef.dismiss();
  }

  deleteContent() {
    this.applyFormFactor.emit('123');
  }

  checkAllSelected(types: any, typeData: any) {
    let selectedType;
    if (!types.every(val => val)) {
      selectedType = types
        .map((checked, i) => (checked ? typeData[i].name : null))
        .filter(v => v !== null)
        .join(', ');
    } else {
      selectedType = [GlobalConstants.ALL].join(',');
    }

    return selectedType;
  }
  isAnySectionNotSelcted() {
    this.noOneSelected = this.isNoneSelected.includes(true) ? true : false;

    return this.noOneSelected;
  }
  getFormFactorName(index: number): string {
    let name = '';
    switch (index) {
      case 0:
        name = GlobalConstants.DEVICE_TYPE;
        break;
      case 1:
        name = GlobalConstants.MANUFACTURER;
        break;
      case 2:
        name = GlobalConstants.PROCESSOR;
        break;
      case 3:
        name = GlobalConstants.GENERATION;
        break;
      default:
        name = '';
        break;
    }

    return name;
  }

  formSubmit() {
    this.isAnyOneOptionSelected();
    if (!this.isAnySectionNotSelcted()) {
      const selectedManufacturers = this.checkAllSelected(
        this.manufacturersForm.value.manufacturers,
        this.formFactorsConfigData.manufacturers
      );
      const selectedDeviceTypes = this.checkAllSelected(
        this.deviceTypesForm.value.deviceTypes,
        this.formFactorsConfigData.deviceTypes
      );
      const selectedProcessors = this.checkAllSelected(
        this.processorsForm.getRawValue().processors,
        this.formFactorsConfigData.processors
      );
      const selectedGenerations = this.checkAllSelected(
        this.generationsForm.value.generations,
        this.formFactorsConfigData.generation
      );
      const isAllFormFactorSelected = (selectedDeviceTypes === GlobalConstants.ALL &&
        selectedManufacturers === GlobalConstants.ALL && selectedProcessors === GlobalConstants.ALL &&
        selectedGenerations === GlobalConstants.ALL) ? true : false;
      this.noOneSelected = false;
      this.selectedFormFactors = {
        allDevices: isAllFormFactorSelected,
        devices: selectedDeviceTypes,
        manufacturer: selectedManufacturers,
        processors: selectedProcessors,
        generations: selectedGenerations
      };
      this.applyFormFactor.emit(this.selectedFormFactors);
    } else {
      this.errorColumns = [];
      this.isNoneSelected.forEach((value, index) => {
        if (value) {
          this.errorColumns.push(this.getFormFactorName(index));
        }
      });
      /* if (name.length > 2) {
         this.errorMessage = `${name.slice(0, -1)
           .join(', ')} ${this.SPACE_AND} ${String(name.slice(-1))} ${this.COLUMNS_CANT_EMPTY}`;
       } else if (name.length === 2) {
         this.errorMessage = `${name.join(this.SPACE_AND)} ${this.COLUMNS_CANT_EMPTY}`;
       } else {
         this.errorMessage = `${name[0]}  ${this.COLUMN_CANT_EMPTY}`;
       } */
    }
  }
}
